export const REGISTER_USER = 'register_user';
export const REGISTER_USER_SUCCESSFUL = 'register_user_successfull';
export const REGISTER_USER_FAILED = 'register_user_failed';

